import type {AsyncTxState, TrackedTx} from "@/lib/types";
import {explorerTxUrl} from "@/lib/chain";

const STATUS: Record<AsyncTxState, {label: string; dot: string; text: string; anim?: string}> = {
  IDLE: {label: "Idle", dot: "bg-forge-ash", text: "text-forge-ash"},
  CONFIRMING: {label: "Confirm in wallet", dot: "bg-molten-400", text: "text-molten-300", anim: "animate-pulseheat"},
  SUBMITTED: {label: "Submitted", dot: "bg-molten-400", text: "text-molten-300", anim: "animate-pulseheat"},
  COMMITTED: {label: "Executor committed", dot: "bg-molten-500", text: "text-molten-300"},
  EXECUTING: {label: "Processing in TEE", dot: "bg-molten-500", text: "text-molten-300", anim: "animate-pulseheat"},
  SETTLING: {label: "Settling on-chain", dot: "bg-molten-400", text: "text-molten-300", anim: "animate-pulseheat"},
  SETTLED: {label: "Settled", dot: "bg-success", text: "text-success"},
  COMPLETED: {label: "Completed", dot: "bg-success", text: "text-success"},
  ERROR: {label: "Failed", dot: "bg-danger", text: "text-danger"},
};

export function TxStatus({tx}: {tx: TrackedTx | null}) {
  if (!tx) return null;
  const s = STATUS[tx.state];

  return (
    <div className="panel-elevated p-3 flex items-start gap-3 text-sm">
      <span className={`mt-1.5 h-2 w-2 rounded-full ${s.dot} ${s.anim ?? ""}`} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className={`font-mono ${s.text}`}>{s.label}</span>
          {tx.hash && (
            <a
              href={explorerTxUrl(tx.hash)}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono text-xs text-forge-ash hover:text-molten-300 underline"
            >
              explorer ↗
            </a>
          )}
        </div>
        <div className="text-xs text-forge-ash mt-0.5">{tx.label}</div>
        {tx.state === "EXECUTING" || tx.state === "SETTLING" || tx.state === "SUBMITTED" ? (
          <div className="mt-2 h-0.5 w-full overflow-hidden rounded bg-forge-border">
            <div className="flow-bar h-full w-full animate-flow" />
          </div>
        ) : null}
        {tx.error && <div className="mt-1 text-xs text-danger mono break-all">{tx.error}</div>}
      </div>
    </div>
  );
}
